function isPhoneNumberKey(evt) {
    var keysArray = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "+", " ", "-", "Spacebar", "Add"];
    return ($.inArray((evt.key).toString(), keysArray) > -1);
}

$(function () {
    $("input#phone").keypress(function (e) {
        return isPhoneNumberKey(e);
    });

    $('[data-toggle="tooltip"]').tooltip()
});
